function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import { MemberSquare } from "../Square/MemberSquare/MemberSquare";
import { MatchHeight } from "../Utility/MatchHeight/MatchHeight";
import { MatchHeightElement } from "../Utility/MatchHeight/MatchHeightElement";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.min.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var MemberCarousel = function MemberCarousel(_ref) {
  var members = _ref.members;
  var carousel = members === null || members === void 0 ? void 0 : members.map(function (member, key) {
    return /*#__PURE__*/_jsx(SwiperSlide, {
      style: {
        width: 'auto',
        marginLeft: key === 0 ? '' : '24px'
      },
      children: /*#__PURE__*/_jsx(MatchHeightElement, {
        group: "member-square",
        children: /*#__PURE__*/_jsx(MemberSquare, _objectSpread({}, member))
      })
    }, key);
  });
  return /*#__PURE__*/_jsx(MatchHeight, {
    children: /*#__PURE__*/_jsx(Swiper, {
      slidesPerView: "auto",
      children: carousel
    })
  });
};